import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import StyledProgressLoader from './StyledProgressLoader';

const ProgressLoader = ({fullscreen = false, background = false, className = false, variant = 'circular', ...rest}) => {
	const props = {
		...rest,
		className: classNames({[className]: !!className, ['no-background']: !background}),
		show: true,
		fullscreen,
		variant
	};

	return <StyledProgressLoader {...props} />;
};

ProgressLoader.propTypes = {
	fullscreen: PropTypes.bool,
	background: PropTypes.bool,
	variant: PropTypes.oneOf(['default', 'circular', 'linear'])
};

export default ProgressLoader;
